import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { AutenticacaoService } from 'src/app/services/autenticacao.service';
import { AdesaoService } from 'src/app/services/adesao.service';
import { DownloadsService } from 'src/app/services/downloads.service';
import { finalize } from 'rxjs/operators';
import { AvisosService } from 'src/app/services/avisos.service';
import { ModalAvisoComponent } from '../modal-aviso/modal-aviso.component';
import { MovimentacoesPartService } from 'src/app/services/movimentacoes-part.service';
import { CadastroService } from 'src/app/services/cadastro.service';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UtilService } from 'src/app/services/util.service';
declare var $: any;

@Component({
    selector: 'app-header-autoatendimento',
    templateUrl: './header-autoatendimento.component.html',
    styleUrls: ['./header-autoatendimento.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [RouterModule, ModalAvisoComponent, CommonModule, FormsModule, ReactiveFormsModule]
})
export class HeaderAutoatendimentoComponent implements OnInit {


  files: any[] = [
    [1, 'fas fa-award', 'Certificado'],
    [2, 'fas fa-file-download', 'Regulamento Plano'],
    [3, 'fas fa-file-download', 'Estatuto Fusan'],
    [4, 'fas fa-file-download', 'Manual Plano'],
    [5, 'fas fa-file-download', 'Política de Investimentos'],
    [6, 'fas fa-file-download', 'Termos de Filiação'],
    [7, 'fas fa-file-download', 'Nota Técnica Atuarial'],
  ];

  simulador_renda_info = 'https://simulador.fundacoesnet.com.br/simulador-adesao-viva-mais-previdencia';
  dt_nasc: string = '';

  status: boolean = false;
  toggled: boolean = false;
  body: HTMLElement;
  header: HTMLElement;
  element: HTMLElement;

  exibeHeader: boolean = false;
  autenticado: boolean = false;

  credenciais: any = null;
  nome: string = "";
  regimeTrib: string = "";

  avisos: any[] = [];
  avisoSemAceite: any[] = [];

  routerURL: string = "";

  numAvisos: number = 0;

  @ViewChild('modalAviso', { static: true }) modalAviso: ModalAvisoComponent;

  constructor(private utilService: UtilService,
              private renderer: Renderer2, private router: Router, private route: ActivatedRoute, private autenticacao: AutenticacaoService, private adesao: AdesaoService, private downloads: DownloadsService, private avisosService: AvisosService, private movimentacoesPart: MovimentacoesPartService, private cadastro: CadastroService) {

    this.listarAvisosNaoLidos();
    this.carregarAvisoSemAceite();
  }

  ngOnInit() {
    this.renderer.addClass(document.body, 'app-autoatendimento');

    this.cadastro
      .buscaDadosPessoais()
      .subscribe(
        (res:any)=>{
          this.dt_nasc = res.DTA_NASC.substring(0, 10);
        })

        this.movimentacoesPart
        .buscaDadosSaldos()
        .subscribe(
          (res:any)=>{
            const contrib = Math.round((res?.valorContribuicao || 0) * 100);
            const saldo = Math.round((res?.saldoFinal || 0) * 100);

              this.simulador_renda_info = `${this.simulador_renda_info}?contrib=${contrib}&nascm=${this.dt_nasc}&saldo=${saldo}`
            }
        )


    this.routerURL = this.router.url;

    this.autenticado = this.autenticacao.isAuthenticated();
    this.credenciais = this.autenticacao.getCredenciais();

    this.nome = this.credenciais.nome;

    this.regimeTrib = this.credenciais.regimeTrib;

    this.autenticacao.userSubject.subscribe((credenciais: any) => {
      this.autenticado = this.autenticacao.isAuthenticated();
      this.credenciais = this.autenticacao.getCredenciais();

      this.nome = this.credenciais.nome;

      this.regimeTrib = this.credenciais.regimeTrib;
    });

    let codUsu = this.credenciais.cod_usuario;

  }

  download(tipo: number, item: any){

    let iconeOriginal = item[1];

    switch(tipo) {

      case 1: {

        item[1] = "fas fa-spinner fa-spin";

        this.adesao.downloadCertificado()
        .pipe(
          finalize(() => { item[1] = iconeOriginal })
        )
        .subscribe(
          (fileData) => {

            let nomeBoleto = 'Certificado.pdf';
            this.utilService.salvarArquivo(fileData, nomeBoleto);
          }
        )


        break;
      }
      case 2: { //Regulamento
         this.windowOpen("https://arquivos.vivamaisprev.com.br/regulamento.pdf");
         break;
      }
      case 3: { //Estatuto Fusan
        this.windowOpen("https://arquivos.vivamaisprev.com.br/estatuto_fusan.pdf");
        break;
      }
      case 4: { //Manual Plano Viva Mais Previdência
        this.windowOpen("https://arquivos.vivamaisprev.com.br/cartilha_explicativa.pdf")
        break;
      }
      case 5: { //Política de Investimento

        item[1] = "fas fa-spinner fa-spin";

        this.downloads.downloadPoliticaInvest()
        .pipe(
          finalize(() => { item[1] = iconeOriginal })
        )
        .subscribe(
          (fileData) => {

            let nome = 'politica_investimento.pdf';
            this.utilService.salvarArquivo(fileData, nome);
          }
        )

        break;
      }
      case 6: { //Termos de Filiação Abrapp

        item[1] = "fas fa-spinner fa-spin";

        this.downloads.downLoadTermoAbrapp()
        .pipe(
          finalize(() => { item[1] = iconeOriginal })
        )
        .subscribe(
          (fileData) => {

            let nome = 'termo_abrapp.pdf';
            this.utilService.salvarArquivo(fileData, nome);
          }
        )

        break;
      }
      case 7: { //Nota Técnica Atuarial
        this.windowOpen("https://arquivos.vivamaisprev.com.br/nota_tecnica_atuarial_vmp.pdf")
        break;
      }
      case 8: { //LGPD
        alert(tipo)
        break;
      }
      default: {
         alert(`Item ${tipo} não encontrado`)
         break;
      }
    }

  }


  sair(){
    this.autenticacao.logout();
    this.router.navigate(['/autenticacao/login']);
  }

  // Toggle Header Mobile
  toggleHeader(event){
    this.toggled = !this.toggled;
    this.header = document.getElementById("master-header");
    this.header.classList.toggle("open");
  }

  // Close Header Mobile
  closeHeader(event){

    this.status = false;
    this.toggled = false;
    this.header = document.getElementById("master-header");
    this.header.classList.remove("open");
  }

  // Toggle MenuPop
  toggleMenuPop(id){

    this.status = !this.status;
    this.element = document.getElementById(id);

    var x = document.querySelectorAll(".menuPop");
    var i;

    for (i = 0; i < x.length; i++) {
      if( x[i].id != id ) {
        x[i].classList.remove("open");
      }
    }

    this.element.classList.toggle("open");

  }

  closeMenuPop(id){
    this.element = document.getElementById(id);
    this.element.classList.remove("open");
  }

  listarAvisosNaoLidos(){

    this.avisosService
        .ListarNaoLidos()
        .subscribe(
          (res: any[]) => {

            this.avisos = res;
            this.numAvisos = res.length;
          }
        )
  }

  carregarAvisoSemAceite(){

    this.avisosService
        .CarregarAvisoSemAceite()
        .subscribe(
          (res: any[]) => {

            if(res !=null){
              this.avisoSemAceite = res;
              this.openModalAViso();
              this.modalAviso.init(this.avisoSemAceite);
            }

          }
        )

  }

  openModalAViso(){
    $('#modalAvisoHeader').modal('show');
    this.closeMenuPop("notifymenu");
  }

  private windowOpen(url) {
    var a = document.createElement('a');
    a.target="_blank";
    a.href=url;
    a.click();
  }

}
